<script>
import { PURPOSE_REWARD_LETTER          } from '../model/pending';
import { PURPOSE_RESTORE_PAYMENT_BY_SKU } from '../model/pending';
import { PURPOSE_REWIND_STORY_TO_QUEST  } from '../model/pending';
import { PURPOSE_FORCE_SPECIAL_OFFER    } from '../model/pending';
import { PURPOSE_FORCE_APPLY_MIGRATION  } from '../model/pending';
import { PURPOSE_FOLLOWING_LINK         } from '../model/pending';
import { PURPOSE_FOR_VIP                } from '../model/pending';

import PlayerPendingInfoRewardLetter          from './PlayerPendingInfoRewardLetter.vue';
import PlayerPendingInfoRestorePaymentBySKU   from './PlayerPendingInfoRestorePaymentBySKU.vue';
import PlayerPendingInfoRewindStoryToQuest    from './PlayerPendingInfoRewindStoryToQuest.vue';
import PlayerPendingInfoForceSpecialOffer     from './PlayerPendingInfoForceSpecialOffer.vue';
import PlayerPendingInfoForceApplyMigration   from './PlayerPendingInfoForceApplyMigration.vue'
import PlayerPendingInfoFollowingLink         from './PlayerPendingInfoFollowingLink.vue'
import PlayerPendingInfoRewardForVip          from './PlayerPendingInfoRewardForVip.vue'

export default {
  name: 'PlayerPendingInfo',

  props: {
    pending: {
      type: Object,
      required: true,
    }
  },

  render(createElement) {
    const componentType = getComponentType(this.pending.purpose);
    const data = {
      props: {
        pending: this.pending,
      },
    };
    return createElement(componentType, data);
  },
}

function getComponentType(purpose) {
  switch(purpose) {
    case PURPOSE_REWARD_LETTER:
      return PlayerPendingInfoRewardLetter;
    case PURPOSE_RESTORE_PAYMENT_BY_SKU:
      return PlayerPendingInfoRestorePaymentBySKU;
    case PURPOSE_REWIND_STORY_TO_QUEST:
      return PlayerPendingInfoRewindStoryToQuest;
    case PURPOSE_FORCE_SPECIAL_OFFER:
      return PlayerPendingInfoForceSpecialOffer;
    case PURPOSE_FORCE_APPLY_MIGRATION:
      return PlayerPendingInfoForceApplyMigration
    case PURPOSE_FOLLOWING_LINK:
      return PlayerPendingInfoFollowingLink
    case PURPOSE_FOR_VIP:
      return PlayerPendingInfoRewardForVip
  }
  return null;
}
</script>
